export default "__VITE_ASSET__Dx7ADWbu__"